var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51904 3C5.61955 3 3.26904 5.35051 3.26904 8.25C3.26904 11.1495 5.61955 13.5 8.51904 13.5C11.4185 13.5 13.769 11.1495 13.769 8.25C13.769 5.35051 11.4185 3 8.51904 3ZM1.76904 8.25C1.76904 4.52208 4.79112 1.5 8.51904 1.5C12.247 1.5 15.269 4.52208 15.269 8.25C15.269 11.9779 12.247 15 8.51904 15C4.79112 15 1.76904 11.9779 1.76904 8.25Z",
    fill: "#2196D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.226 11.9572C12.5189 11.6643 12.9938 11.6643 13.2867 11.9572L16.5492 15.2197C16.8421 15.5126 16.8421 15.9875 16.5492 16.2804C16.2563 16.5733 15.7814 16.5733 15.4885 16.2804L12.226 13.0179C11.9331 12.725 11.9331 12.2501 12.226 11.9572Z",
    fill: "#2196D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.32d446eff540d6758379be26e6ba0552.svg";
export { ForwardRef as ReactComponent };